// first level
import { normalizeProductName, normalizeProductFilters } from "./general-info";
// second level
import {
  normalizeOffers,
  normalizeProductOffering,
  normalizeDefaultProductAlias,
} from "./offer";

import { normalizeProductCharacteristics } from "./characteristics";

function normalizeDictionary(product, offer) {
  let res = {};

  res.name = normalizeProductName(product, res);
  res.filters = normalizeProductFilters(product);
  res.productOffering = normalizeProductOffering(product, offer);
  res.offers = normalizeOffers(product, offer);
  res.defaultProduct = normalizeDefaultProductAlias(product, offer);
  res.characteristics = normalizeProductCharacteristics(product, offer);

  return res;
}

function main(products, offer) {
  let finalProducts = {};

  if (!products || !Array.isArray(products) || !offer) return null;

  for (let product of products) {
    if (product?.alias) {
      finalProducts[product.alias] = normalizeDictionary(product, offer);
    }
  }

  return finalProducts;
}

export default main;
